import CenteredHeader from "./../../Molecules/CenteredHeader/CenteredHeader";
import IndustryImageTextSection from "./../../Molecules/IndustryImageTextSection/IndustryImageTextSection";
import BOTE from "../../../assets/img/BOTE.jpg";
import IndustryLightBlueSection from "./../../Organisms/IndustryLightBlueSection/IndustryLightBlueSection";
import IndustryBannerBgSection from "./../../Atoms/IndustryBannerBgSection/IndustryBannerBgSection";
import FLOTA_MARINA_BANNER_RIGHT_IMAGE from "../../../assets/img/FLOTA_MARINA_BANNER_RIGHT_IMAGE.png";
import IndustryTwoButtonsSection from "./../../Atoms/IndustryTwoButtonsSection/IndustryTwoButtonsSection";
import FLOTA_MARINA_DASHBOARD_IMG from "../../../assets/img/FLOTA_MARINA_DASHBOARD_IMG.png";
import IndustryFooterButtonSection from "./../../Atoms/IndustryFooterButtonSection/IndustryFooterButtonSection";
import content from "./content";
import { useLanguageCtx } from "../../../store/providers/LanguageContext";
import { useScrollCtx } from "../../../store/providers/ScrollContext";
import ChangeableHeaderV2 from "../../Molecules/ChangeableHeaderV2/ChangeableHeaderV2";

const FamilyBotes = () => {
	const { language } = useLanguageCtx();
	const { dropdownHeader } = useScrollCtx();

  return (
		<>
			<ChangeableHeaderV2
				appearSecondNavbar={dropdownHeader} 
				withTitle
				titleBanner={content[language].header_title}
				route="flota-marina"
			/>

			<div className="top-space-section">
				<CenteredHeader
					yellowText={content[language].botes_yellow_title}
					boldText={content[language].botes_bold_title}
				/>
			</div>

			<div className="top-space-section">
				<IndustryImageTextSection
					image={{
						img: BOTE,
						alt: "Tablet con Graficos en Pantalla",
					}}
					imgRadius
					boldText={content[language].botes_bold_text}
					paragraphs={content[language].botes_text}
				/>
			</div>

			<div className="top-space-section">
				<IndustryLightBlueSection
					yellowText={content[language].beneficios_yellow_title}
					checkText={content[language].beneficios_list}
				/>
			</div>

			<IndustryBannerBgSection route="botes">
				<IndustryImageTextSection
					switchOrder
					inBanner
					image={{ img: FLOTA_MARINA_BANNER_RIGHT_IMAGE, alt: "Barco" }}
					yellowText={content[language].caracteristicas_yellow_title}
					boldText={content[language].caracteristicas_bold_title}
					checkText={content[language].caracteristicas_list}
				/>
			</IndustryBannerBgSection>

			<IndustryTwoButtonsSection />

			<div className="top-space-section">
				<CenteredHeader
					yellowText={content[language].dashboard_yellow_title}
					boldText={content[language].dashboard_bold_title}
				/>
			</div>

			<div className="top-space-section no-top-space-responsive bottom-space-section">
				<IndustryImageTextSection
					image={{
						img: FLOTA_MARINA_DASHBOARD_IMG,
						alt: "Tablet con Mapa en Pantalla",
					}}
					boldText={content[language].dashboard_bold_text}
					paragraphs={content[language].dashboard_text}
					checkText={content[language].dashboard_list}
					responsiveImgPosition="last"
				/>
			</div>

			<IndustryFooterButtonSection />
		</>
	);
};

export default FamilyBotes;
